import { createApiClient } from '@assay/shared/apiClient';

/**
 * The web app's API client.
 *
 * No `getToken`: the browser sends the Clerk session cookie automatically on
 * same-origin requests, so an Authorization header would be redundant. The
 * mobile app builds its own instance with an absolute base URL and Clerk's
 * `getToken` (see apps/mobile).
 *
 * Paths passed to this client are relative to `/api`, so call `api.get('/contacts')`,
 * not `api.get('/api/contacts')`.
 */
export const api = createApiClient({ baseUrl: '/api' });
